<template>
  <b-container>
    <!-- Document number -->
    <b-form-group
      :label="$t('gasStation.fields.documentNumber')"
      label-for="documentNumber"
    >
      <b-form-input
        id="documentNumber"
        type="text"
        :placeholder="$t('gasStation.fields.documentNumberTooltip')"
        v-model="model.documentNumber"
        v-mask="'99.999.999/9999-99'"
      />
      <span class="text-danger" v-if="modelstate['DocumentNumber']">
        {{ modelstate["DocumentNumber"][0] }}
      </span>
    </b-form-group>

    <!-- Company name -->
    <b-form-group
      :label="$t('gasStation.fields.companyName')"
      label-for="companyName"
    >
      <b-form-input
        id="companyName"
        type="text"
        :placeholder="$t('gasStation.fields.companyNameTooltip')"
        v-model="model.companyName"
      />
      <span class="text-danger" v-if="modelstate['CompanyName']">
        {{ modelstate["CompanyName"][0] }}
      </span>
    </b-form-group>

    <!-- Fantasy name -->
    <b-form-group
      :label="$t('gasStation.fields.fantasyName')"
      label-for="fantasyName"
    >
      <b-form-input
        id="fantasyName"
        type="text"
        :placeholder="$t('gasStation.fields.fantasyNameTooltip')"
        v-model="model.fantasyName"
      />
      <span class="text-danger" v-if="modelstate['FantasyName']">
        {{ modelstate["FantasyName"][0] }}
      </span>
    </b-form-group>

    <!-- Sate -->
    <b-form-group
      :label="$t('gasStation.fields.state')"
      label-for="OriginStateId"
    >
      <state-dropdown
        id="stateId"
        :state-id="parseInt(model.stateId)"
        :changeId.sync="model.stateId"
      >
      </state-dropdown>
      <span class="text-danger" v-if="modelstate['StateId']">
        {{ modelstate["StateId"][0] }}
      </span>
    </b-form-group>

    <!-- City -->
    <b-form-group :label="$t('gasStation.fields.city')" label-for="cityId">
      <CityDropdown
        id="cityId"
        :readonly="readonly"
        :state-id="parseInt(model.stateId)"
        :city-id="model.cityId"
        :changeData.sync="model.cityId"
      />
      <span class="text-danger" v-if="modelstate['CityId']">
        {{ modelstate["CityId"][0] }}
      </span>
    </b-form-group>
    <div class="mt-4">
      <!-- IsInternalGasStation -->
      <b-form-group class="mb-3">
        <b-form-checkbox
          id="isInternalGasStation"
          v-model="model.isInternalGasStation"
          :value="true"
          :unchecked-value="false"
        >
          {{ $t("gasStation.fields.isInternalGasStation") }}
        </b-form-checkbox>
        <span class="text-danger" v-if="modelstate['IsInternalGasStation']">
          {{ modelstate["IsInternalGasStation"][0] }}
        </span>
      </b-form-group>

      <!-- IsExternalGasStation -->
      <b-form-group class="mb-3">
        <b-form-checkbox
          id="isExternalGasStation"
          v-model="model.isExternalGasStation"
          :value="true"
          :unchecked-value="false"
        >
          {{ $t("gasStation.fields.isExternalGasStation") }}
        </b-form-checkbox>
        <span class="text-danger" v-if="modelstate['IsExternalGasStation']">
          {{ modelstate["IsExternalGasStation"][0] }}
        </span>
      </b-form-group>
    </div>
  </b-container>
</template>
  
<script>
import AwesomeMask from "awesome-mask";

export default {
  name: "GasStationCrud",
  props: {
    model: {
      type: Object,
      description: "Posto de gasolina",
      default() {
        return {
          documentNumber: "",
          companyName: "",
          fantasyName: "",
          cityId: null,
        };
      },
    },
    modelstate: {
      type: Object,
      description: "Estado do salvamento",
      default() {
        return {};
      },
    },
  },
  components: {
    CityDropdown: () => import("@/components_rms/System/city/CityDropdown.vue"),
    StateDropdown: () =>
      import("@/components_rms/System/state/StateDropdown.vue"),
  },
  created() {
    this.getAllVehicleType();
    // this.dataFormat();
  },
  data() {
    return {
      vehicleTypeOpt: [],
    };
  },
  directives: {
    mask: AwesomeMask,
  },
  methods: {
    getAllVehicleType() {
      this.$apiVehicle.get("/vehicleType/getDropdown/").then((response) => {
        this.vehicleTypeOpt = response.data;
      });
    },
  },
};
</script>
  